
import {connect} from 'react-redux';
import { INSIDER_CATEGORY, INSIDER_CTA_CLICK, sendEventTracking } from '../actions/trackingEvents'
import InsiderCta from '../components/InsiderCta'

const mapStateToProps = state => {
    return {
        loggedIn: state.common.auth.loggedIn
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fireEventTracking: () => {
            dispatch(sendEventTracking(INSIDER_CATEGORY, INSIDER_CTA_CLICK))
        }
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(InsiderCta)


// WEBPACK FOOTER //
// ./modules/Common/containers/InsiderCta.js